import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(): Promise<Optional<ResponseStatus[]>> {
	const url = `${SERVICEBASEURL.BACKEND}/Status`;
	return axios.get(url).toOptionalMapped((x) => x.data.statusList);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	statusList: ResponseStatus[];
};

export type ResponseStatus = {
	id: string;
	name: string;
	order: number;
	color: string;
};
